import React, { useEffect, useRef, useState } from "react";
import { getCasesReportMetrics } from "../../../../api";
import { Card } from "@mui/material";
import { Divider } from "@monolith-forensics/monolith-ui";
import DropDownSelector from "../../../../components/DropDownSelector";
import DefaultPieChart from "../DefaultPieChart";
import DefaultTextChart from "../DefaultTextChart";
import Loader from "../../../../components/Loader";

const views = [
  {
    text: "Charts",
    value: 0,
  },
  {
    text: "Text",
    value: 1,
  },
];

const CaseReportComposition = ({ reportInfo }) => {
  const [metrics, setMetrics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentView, setCurrentView] = useState(0);

  useEffect(() => {
    getCasesReportMetrics({
      ...reportInfo.report_parameters,
      dimension: "composition",
    }).then((result) => {
      setMetrics(result);
      setIsLoading(false);
    });
  }, []);

  return (
    <Card
      style={{
        padding: "20px",
        marginBottom: "20px",
        height: "350px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "larger",
            }}
          >
            Case Composition
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ marginRight: "10px" }}>
              <DropDownSelector
                items={views}
                useSelectMode={true}
                selectedItem={currentView}
                displayExpr="text"
                variant="contained"
                onSelect={(item) => {
                  setCurrentView(item.value);
                }}
              />
            </div>
          </div>
        </div>
        <Divider style={{ margin: "16px 0" }} />
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        )}
        {!isLoading && currentView === 0 && (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <DefaultPieChart
              data={metrics.type_comp}
              title="Case Types"
              valueExpr="type_name"
            />
            <DefaultPieChart
              data={metrics.status_comp}
              title="Case Status"
              valueExpr="status_name"
            />
            <DefaultPieChart
              data={metrics.progress_comp}
              title="Case Progress"
              valueExpr="progress_name"
            />
            <DefaultPieChart
              data={metrics.org_comp}
              title="Organizations"
              valueExpr="org_name"
            />
          </div>
        )}
        {!isLoading && currentView === 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              userSelect: "text",
            }}
          >
            <DefaultTextChart
              data={metrics.type_comp}
              title="Case Types"
              valueExpr="type_name"
            />
            <DefaultTextChart
              data={metrics.status_comp}
              title="Case Status"
              valueExpr="status_name"
            />
            <DefaultTextChart
              data={metrics.progress_comp}
              title="Case Progress"
              valueExpr="progress_name"
            />
            <DefaultTextChart
              data={metrics.org_comp}
              title="Organizations"
              valueExpr="org_name"
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default CaseReportComposition;
